export const findProcessError = (errorConstant) => {
    switch(errorConstant){
        case "INVALID_MEMBER_IDENTIFIERS":
            return "Member Identifiers did not contain required components."
        case "INVALID_STATE":   
            return "Required information is not present in the process state object"
        case "UNKNOWN_UUID":
            return "Given UUID matches no known Healthsafe UUID."
        case "ESSO_PROFILE_NOT_FOUND":
            return "No ESSO User Profile found for given UUID."  
        case "NO_ACCOUNT_RECOVERY_OPTIONS":
            return "User's ESSO Profile does not contain a email address or phone number."
        case "EMAIL_OR_PHONE_NOT_VERIFIED":
            return "User's ESSO Profile does not contain a verified email address or phone number."
        case "USER_LOOKUP_FAILED":
            return "Lookup API failed, eligibility data not found."
        case "MEMBER_NOT_ELIGIBLE_FOR_DESTINATION":
            return "Member is not eligible for the destination portal."
        case "NO_HSID_FOUND":
            return "No HSID found while searching for existing or duplicates."
        case "HEADLESS_ID_EXISTS_FOR_USER":
            return "Headless exists for this user"
        case "HEALTHSAFE_ALREADY_EXISTS_FOR_USER":
            return "Healthsafe already exist for this user."
        case "ELIGIBILITY_PROV_MULTIPLE_RECORD_ERROR":
            return "Multiple records found in PDB"
        case "MDM_GOLDEN_NOT_FOUND":
            return "Didn't find MDM Golden record."
        case "OPEN_TOKEN_INVALID":
            return "Token is expired or has no values"
        case "USER_LOCKED":
            return "User account had locked status"
        case "INVALID_SSO_TYPE":
            return "Invalid or missing ssoType";
        case "INTERNAL_ERROR":
            return "Unexpected exception"
        case "INVALID_USER_INPUTS":
            return "User inputs are not matching with mdm response"
        case "MISCONFIGURED_OPERATION":
            return "An operation in the process is missing required configuration"
        case "PROVISION_DATASTORE_ERROR":
            return "Provision Datastore Failure"
        case "ESSO_SERVICE_ERROR":
            return "ESSO Service Failure"
        case "USER_DATASTORE_ERROR":
            return "User Datastore Failure"
        case "CONFIG_SERVICE_FAILURE":
            return "Portal Config Service Failure"
        case "ESSO_CREATION_FAILURE":
            return "Error creating Esso Profile"
        case "ESSO_PROFILE_UPDATE_FAILURE":
            return "Error Updating ESSO Profile"
        case "HEADLESS_UPDATE_FAILURE":
            return "Error updating headless Username and password"
        case "DLWS_SERVICE_ERROR":
            return "DLWS service failure"
        case "UNKNOWN_EXCEPTION":
            return "Unexpected exception occurred during processing."
        default:
            return errorConstant
    }
}